import { defineStore } from "pinia";

export const useAbsenceStore = defineStore('absence', {
    state: () => {
      return {
        teamId: 0,
        locationId: 0,
        statusId: "absent",
        withSubstitutes: false,
      }
    },
    persist: true,
});